
  var _styles = {
  "light-up-city-share-main": {
    "width": "10rem",
    "height": "8.93333rem",
    "display": "flex",
    "alignItems": "center"
  },
  "light-up-city-share-head-tips": {
    "fontWeight": "400",
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.29333rem",
    "lineHeight": "0.42667rem",
    "height": "0.42667rem",
    "textAlign": "center",
    "marginTop": "0.10667rem",
    "marginBottom": "0.26667rem",
    "zIndex": 1
  },
  "light-up-city-content": {
    "width": "9.05333rem",
    "height": "4.12rem",
    "borderRadius": "0.42667rem",
    "background": "#eefde6",
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "center",
    "zIndex": 1
  },
  "light-up-city-content-city-content-tips": {
    "width": "100%",
    "height": "0.52rem",
    "fontWeight": "400",
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.37333rem",
    "lineHeight": "0.52rem",
    "textAlign": "center",
    "marginTop": "0.08rem"
  },
  "light-up-city-content-city-name": {
    "width": "100%",
    "height": "1.45333rem",
    "color": "rgb(17,17,17)",
    "fontFamily": "MTNewDigitalDisplay-Bold",
    "fontWeight": "700",
    "fontSize": "1.04rem",
    "lineHeight": "1.45333rem",
    "textAlign": "center"
  },
  "light-up-city-share-city-card": {
    "zIndex": 1
  },
  "light-up-city-share-buttons": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "zIndex": 1,
    "height": "1.2rem",
    "width": "100%",
    "marginTop": "0.6rem"
  },
  "light-up-city-share-back-btn": {
    "width": "3.24rem",
    "height": "1.2rem",
    "borderRadius": "1.2rem",
    "borderWidth": "0.02667rem",
    "borderStyle": "solid",
    "borderColor": "rgb(30,138,25)",
    "marginRight": "0.24rem"
  },
  "light-up-city-share-back-btn-text": {
    "color": "rgb(30,138,25)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.42667rem",
    "lineHeight": "1.2rem",
    "height": "1.2rem",
    "textAlign": "center"
  },
  "light-up-city-share-button-wrap": {
    "position": "relative"
  },
  "light-up-city-share-button-tips": {
    "position": "absolute",
    "top": "-0.26667rem",
    "right": 0,
    "borderRadius": "0.33333rem 0.33333rem 0.33333rem 0.06667rem",
    "background": "#ff2d19",
    "height": "0.50667rem",
    "width": "2.70667rem"
  },
  "light-up-city-share-button-tips-text": {
    "fontWeight": "400",
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.26667rem",
    "lineHeight": "0.50667rem",
    "textAlign": "center"
  }
};



  module.exports = _styles;
  